module.exports = __webpack_public_path__ + "img/Marca11.7064d5d7.jpg";